import { render, staticRenderFns } from "./DonutChartComercial.vue?vue&type=template&id=48695ee8&"
import script from "./DonutChartComercial.vue?vue&type=script&lang=js&"
export * from "./DonutChartComercial.vue?vue&type=script&lang=js&"
import style0 from "./DonutChartComercial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports